import {
    HttpResponse,
    ShiftModel,
    QueryModel,
    RequestParams,
    ShiftModelIEnumerableApiResultSuccess,
    ShiftModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class ShiftsDataService implements CrudService<ShiftModel, ShiftModel> {
    getAll(query: CrudDataQuery<ShiftModel>): Promise<CrudEnumerableResponse<ShiftModel>> {
        return ApiService.api.getShiftBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<ShiftModel>): Promise<CrudEnumerableResponse<ShiftModel>> {
        return ApiService.api.getShiftsBasicBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ShiftModel>> {
        return ApiService.api.getShiftById(id, params);
    }

    create(item: ShiftModel, params?: RequestParams): Promise<CrudResponse<ShiftModel>> {
        return ApiService.api.insertShift(item, params);
    }

    update(item: ShiftModel, params?: RequestParams): Promise<ShiftModel> {
        return ApiService.api.updateShift(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ShiftModel> {
        return ApiService.api.patchShift(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ShiftModel>): Promise<CrudEnumerableResponse<ShiftModel>> {
        return ApiService.api.deleteShifts(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationShift(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<ShiftModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: ShiftModel, params?: RequestParams): Promise<CrudResponse<ShiftModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getShiftGroupped(query, params);
    }

}
